var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.754714 12.1913C-0.304661 12.7791 -0.206224 14.3465 0.923464 14.8021L7.50003 17.4676V22.1742C7.50003 22.9989 8.1844 23.6642 9.03284 23.6642C9.48753 23.6642 9.91878 23.4682 10.2094 23.1265L13.1157 19.7412L18.9235 22.0922C19.8094 22.4522 20.836 21.8872 20.9813 20.9668L23.9813 2.01253C24.0703 1.46122 23.8219 0.905347 23.3485 0.59096C22.875 0.276574 22.2563 0.249236 21.7547 0.527172L0.754714 12.1913ZM3.1969 13.3532L19.2047 4.46383L8.91096 15.645L8.96721 15.6906L3.1969 13.3532ZM18.9047 19.7184L11.0953 16.5517L21.1313 5.64848L18.9047 19.7184Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.3284,
    fill: "white",
    transform: "translate(0 0.335815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fd865e311606e7a0c9d730723c7e94e2.svg";
export { ForwardRef as ReactComponent };